export function flatten(obj: Record<string, any>) {
  return Object.values(obj)
}
